// extracted by mini-css-extract-plugin
export default {"Octicon":"memex-item-icon-module__Octicon--sONUc"};